import React from 'react';
import PropTypes from 'prop-types';
import routesModule from '../../../../../utilities/routes_module';

const DoneBanner = ({ action }) => {
  return (
    <div className='text-center' data-testid='done-banner'>
      <div className='icon-wrap v-margin-large'>
        <svg
          className='animated_tick'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlnsXlink='http://www.w3.org/1999/xlink'
          viewBox='0 0 161.2 161.2'
          xmlSpace='preserve'
        >
          <path
            className='path'
            fill='none'
            stroke='#66cc66'
            strokeMiterlimit='10'
            d={`
              M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4c-2.\
              3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,\
              0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5c0.3-0.3,0.5-0.6,0.7-0.\
              9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z`}
          />
          <circle
            className='path'
            fill='none'
            stroke='#66cc66'
            strokeWidth='4'
            strokeMiterlimit='10'
            cx='80.6'
            cy='80.6'
            r='62.1'
          />
          <polyline
            className='path'
            fill='none'
            stroke='#66cc66'
            strokeWidth='6'
            strokeLinecap='round'
            strokeMiterlimit='10'
            points='113,52.8 74.1,108.4 48.2,86.4'
          />
        </svg>
      </div>
      <p>Thanks for {action} your information.</p>
      <p className='margin-top-medium'>
        Click <a href={routesModule.edit_profile_index_path()}>here</a> to view or edit your updated
        profile.
      </p>
    </div>
  );
};

DoneBanner.propTypes = {
  action: PropTypes.string,
};

export default DoneBanner;
